/*
 * Cart upsell carousel: variant selection, one-click add, and arrow scrolling.
 * Add + arrows are delegated on document so they survive re-renders.
 */
(function () {
  // --- per-card variant selection ---
  function initCard(card) {
    if (card.dataset.cuInit) return;
    card.dataset.cuInit = '1';
    var json = card.querySelector('[data-cu-variants]');
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var selects = card.querySelectorAll('[data-cu-opt]');
    var btn = card.querySelector('[data-cart-upsell-add]');
    var priceEl = card.querySelector('[data-cu-price]');
    if (!selects.length || !variants.length || !btn) return;

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.opts.length === chosen.length && v.opts.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      btn.setAttribute('data-variant-id', match.id);
      if (match.available) { btn.removeAttribute('disabled'); } else { btn.setAttribute('disabled', ''); }
      if (priceEl) {
        priceEl.innerHTML = '<strong>' + match.price + '</strong>' + (match.cprice ? ' <s>' + match.cprice + '</s>' : '');
      }
    }
    Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', update); });
  }
  function initAll() { document.querySelectorAll('[data-cu-card]').forEach(initCard); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }

  // --- delegated clicks: arrows + add ---
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-cu-arrow]');
    if (arrow) {
      var wrap = arrow.closest('[data-cart-upsell]');
      var track = wrap && wrap.querySelector('[data-cu-track]');
      if (!track) return;
      var dir = parseInt(arrow.getAttribute('data-cu-arrow'), 10) || 1;
      var card = track.querySelector('.cu-card');
      var step = card ? card.offsetWidth + 12 : 240;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
      return;
    }

    var addBtn = e.target.closest('[data-cart-upsell-add]');
    if (!addBtn || addBtn.hasAttribute('disabled')) return;
    e.preventDefault();
    var id = addBtn.getAttribute('data-variant-id');
    if (!id) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    addBtn.setAttribute('disabled', '');

    var body = { items: [{ id: id, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { addBtn.removeAttribute('disabled'); return; }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(res);
          if (typeof cart.open === 'function') cart.open();
        } else {
          window.location = root + 'cart';
        }
      })
      .catch(function () { addBtn.removeAttribute('disabled'); });
  });
})();
